<template>
  <div class="cadfm-container-horizontal">
            <Left v-show="isVisibleLeft" :lang="lang.Left"></Left>
            <Middle  :lang="lang.Middle"></Middle>
            <Right v-show="isVisibleRight" :lang="lang.Right" ></Right>

 </div>
</template>

<script>
import Left from '@/components/ProjectManager/Views/ProjectBom/Left/Left'
import Middle from '@/components/ProjectManager/Views/ProjectBom/Middle/Middle'
import Right from '@/components/ProjectManager/Views/ProjectBom/Right/Right'
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'


export default {
  name: 'ProjectBom',
  components:{
    Left,
    Middle,
    Right
  },
  data () {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    }
  },
  props:{
    routingData: Object,
    lang: Object
  },
}
</script>


<style scoped>
  .ProjectBom{
    
  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectBom.vue